import * as Icons from "lucide-react";
import { Reveal, Chapter } from "../../lib/motion";
import { FEATURES, INDUSTRIES, IMAGES } from "../../data";

export default function WhyChoose() {
  return (
    <section data-testid="why-choose" className="py-24 md:py-32 bg-verra-base">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Chapter number="03" overline="Why Verraleaf" title="Engineered for performance. Made for the planet." />

        <div className="grid md:grid-cols-4 gap-5">
          <Reveal className="md:col-span-2 md:row-span-2">
            <div className="relative h-full min-h-[280px] rounded-2xl overflow-hidden">
              <img src={IMAGES.leaves} alt="Green leaves" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-verra-blue/90 to-verra-blue/20" />
              <div className="relative p-8 h-full flex flex-col justify-end">
                <h3 className="font-display text-3xl text-white">Nature, refined into function.</h3>
                <p className="text-white/70 mt-3 max-w-sm">Every product is compostable, plastic-free and built to export standards — proof that sustainability and quality belong together.</p>
              </div>
            </div>
          </Reveal>

          {FEATURES.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Leaf;
            return (
              <Reveal key={f.title} delay={0.04 * i}>
                <div className="h-full rounded-2xl bg-white border border-verra-blue/10 p-6 hover:-translate-y-1 transition-transform duration-300">
                  <div className="w-11 h-11 rounded-xl bg-verra-light/25 flex items-center justify-center mb-4">
                    <Icon className="w-5 h-5 text-verra-green" />
                  </div>
                  <p className="font-semibold text-verra-blue leading-snug">{f.title}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        {/* Industries */}
        <div className="mt-28">
          <Chapter number="04" overline="Industries We Serve" title="Trusted across the food ecosystem." />
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind} delay={0.03 * i}>
                <div
                  data-testid={`industry-${ind.toLowerCase().replace(/\s+/g, "-")}`}
                  className="group rounded-2xl bg-white border border-verra-blue/10 px-6 py-8 text-center hover:bg-verra-green transition-colors duration-300"
                >
                  <p className="font-display text-xl text-verra-blue group-hover:text-white transition-colors duration-300">{ind}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
